<template>
  <div>
    <div class="flex mt-4">
      <div class="w-1/2">
        <p :class="['text-md font-bold', theme.AdditionsPopUp.HeadertextColor]">{{ modifier[`name_${language}`] }}</p>
      </div>

      <div class="w-1/2">
      
         <p v-if="$_.max(modifier.Additions, (item) => { return item.price }).price > 0" :class="['text-md font-bold', theme.AdditionsPopUp.HeadertextColor]">{{lang["Charges"][this.language]}}</p>
      </div>
    </div>

    <div
      :class="['mt-2 py-1 flex rounded-large p-2 shadow-lg transition duration-500  hover:shadow-xl', theme.addToCart.backgroundColor]"
      v-for="addition in modifier.Additions"
      :key="addition.Id"
    >
      <div class="w-1/2">
        <label class="block">
          <span :class="[theme.body.textColor]">{{ addition[`name_${language}`] }}</span>
        </label>
      </div>

      <div class="w-1/2 flex">
        <div v-if="addition.price > 0" :class="['w-3/4', theme.body.textColor]">
        {{currency}} {{addition.price}}
        </div>
        <div v-else :class="['w-3/4', theme.body.textColor]">
        </div>
        <div class="w-1/4">
          <input
            @click="selectModifier(modifier.AdditionGroupId)"
            v-model="selectedModifiers"
            class="mr-2 leading-tight"
            type="checkbox"
            :disabled="
              selectedModifiers.indexOf(addition) === -1 && disableModifiers
            "
            :value="addition"
            :name="modifier[`name_${language}`]"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import lang from "../lang";
import { mapGetters } from "vuex";
export default {
  props: {
    modifier: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      lang: lang,
      selectedModifiers: [],
      disableModifiers: false,
      modifiersMessage: "",
    };
  },
  watch: {
    selectedModifiers(currentValue) {
      /** Disable add to cart button disabled when minimum one modifers is allowed. */
      if (this.modifier.minSelectedAmount == 1) {
        if (currentValue.length >= this.modifier.minSelectedAmount) {
          window.$eventBus.$emit("add-to-cart-button-disable", false);
          this.modifiersMessage = "";
        } else {
          this.modifiersMessage = this.lang["minimum_one_item_is_required"][
            this.language
          ];
          window.$eventBus.$emit("add-to-cart-button-disable", true);
        }
      }

      /** In Case when Unlimited Modifieres are allowed */
      if (this.modifier.maxSelectedAmount == -1) {
        this.modifiersMessage = this.lang["multiple_modifiers_can_be_selected"][
          this.language
        ];
        return (this.disableModifiers = false);
      }

      if (this.modifier.maxSelectedAmount == 1) {
        /** When one modifier is selected then disable the further selection. */
        if (currentValue.length == 1) {
          this.modifiersMessage = this.lang["only_one_modifier_allowed"][
            this.language
          ];
          return (this.disableModifiers = true);
        } else {
          return (this.disableModifiers = false);
        }
      }
      return (this.disableModifiers = false);
    },
  },
  methods: {
    selectModifier(modifierGroupId) {
      setTimeout(() => {
        window.$eventBus.$emit("additions-selected", {
          modifierGroupId: modifierGroupId,
          selectedModifiers: this.selectedModifiers,
        });
      }, 100);
    },
  },
  computed: {
    ...mapGetters(["language","currency","theme"]),
  },
  mounted() {
    if (this.modifier.minSelectedAmount >= 1) {
      window.$eventBus.$emit("add-to-cart-button-disable", true);
      return (this.modifiersMessage = this.lang["minimum_one_item_is_required"][
        this.language
      ]);
    }

    if (this.modifier.maxSelectedAmount == -1) {
      this.modifiersMessage = this.lang["multiple_modifiers_can_be_selected"][
        this.language
      ];
    }

    if (this.modifier.maxSelectedAmount == 1) {
      this.modifiersMessage = this.lang["only_one_modifier_allowed"][
        this.language
      ];
    }
  },
};
</script>